import { render, staticRenderFns } from "./CommunicationTypeChangeActivationType.vue?vue&type=template&id=706ef3a0&"
import script from "./CommunicationTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports